import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import illustration from "../../../assets/images/appImages/illustration.png";
import { TeamData } from "./data";


export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
  twitter,
  facebook,
  linkedin,
}: {
  photo?: string;
  name: string;
  role: string;
  twitter?: string;
  facebook?: string;
  linkedin?: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};



function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5 pb-5">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="illustration-container">
                  <img loading="lazy" src={illustration} alt="image" />
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <CustomBeautyTitle title="Qui sommes nous?" />
                <h3 className="custom-title">Ajamaat Mobilité</h3>
                <div className="custom-content">
                  Ajamaat mobilité est un supermarché en ligne qui offre la possibilité aux consommateurs de faire leurs
                  courses de manières pratique et efficace de chez eux ou de leur bureaux. C'est un service qui s'adresse
                  aussi bien aux particuliers qu'aux professionnels.
                  <br />
                  Nous proposons une large gamme de produits car nous sommes en contact direct avec des grossistes, des
                  supermarchés physiques, des producteurs de fruits et légumes locaux, des mareyeurs et volaillers.
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="custom-content">
                  Une fois les paniers finalisés par nos préparateurs de commandes, ce sont nos agents qui vous livrent en
                  toute sécurité dans le créneaux horaires que vous aurez choisi.
                </div>
              </div>
              <div className="col-lg-12 mb-4">
                <div className="pb-3 para custom-content">
                  <h5>
                    <strong>Nos valeurs</strong>
                  </h5>
                  <p className="pb-2 custom-content">
                    Ajamaat Business Corporate a pour objectif de réduire les inégalités sociales et d'impacter positivement sur
                    l' employabilité des couches vulnérables que compte la région de Ziguinchor. Ajamaat mobilité  propose des
                    solutions adaptées aux nouveaux besoins des clients , ainsi qu'une réponse rapide et fiable. <br />
                    Nous mettons aussi tout en œuvre pour faciliter et simplifier l'expérience de nos clients.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 our-team gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Notre équipe</h3>
              <div className="row pt-4">
                {!!TeamData &&
                  TeamData.map((member, key) => {
                    return (
                      <div className="col-lg-4 col-md-4 mb-4 card-wrapper" key={key}>
                        <TeamCard
                          photo={member.photo}
                          name={member.name}
                          role={member.role}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

        </div>

      </div>
      <div style={{ padding: '5rem 0' }}></div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
